export default class PersonList {
	constructor(config) {
		this.el = config.el || document.querySelectorAll(".personList");
		this.triggers = this.el.querySelectorAll(".personList__trigger");
		this.expandedClass = "personList__group--expanded";
		this.init();
	}
	init() {
		const self = this;
		this.attachEvents();
	}
	attachEvents() {
		const self = this;
		this.triggers.forEach(trigger => {
			trigger.addEventListener("click", function() {
				self.togglePerson(trigger.parentElement);
			});
		});
	}
	togglePerson(person) {
		if (person.classList.contains(this.expandedClass)) {
			this.collapsePerson(person);
		} else {
			this.expandPerson(person);
		}
	}
	expandPerson(personItem) {
		personItem.classList.add(this.expandedClass);
	}
	collapsePerson(personItem) {
		personItem.classList.remove(this.expandedClass);
	}
}
